/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgEmailCheck = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="m22.769 15.64-5.702 6.841-3.774-3.774 1.414-1.414 2.225 2.225 4.3-5.159z" />
        <path d="M22 12h-2V5.227l-8 7.11-8-7.11V18h7v2H2V2h20zM12 9.662 18.37 4H5.63z" />
      </g>
    </g>
  </Icon>
);
export { SvgEmailCheck as EmailCheck };
